/**
 * Layout for the home videos section, picked from the number of videos
 * (the mockup's 1 to 5 variations):
 *
 *   0       'none'     - nothing renders
 *   1       'single'   - one featured card, horizontal
 *   2       'pair'     - two featured cards, 50 / 50
 *   3 to 5  'featured' - first video featured (1/3), the rest as rows (2/3)
 *
 * @param {number} count
 * @returns {'none'|'single'|'pair'|'featured'}
 */
export default function selectLayout(count) {
  if (!count || count < 1) return 'none';
  if (count === 1) return 'single';
  if (count === 2) return 'pair';
  return 'featured';
}
